export const trackingPixelsRule = {
  id: 'tracking-pixels',
  name: 'Tracking Pixels',
  description: 'Network tracking requests should have been sent during ad playback',

  check(session) {
    const errors = session.events.filter(e => e.type === 'aderror');
    if (errors.length > 0 && session.networkLog.length === 0) {
      return { status: 'na', message: 'Ad errored; no tracking expected' };
    }

    if (session.networkLog.length === 0) {
      const hasAdStarted = session.events.some(e => e.type === 'adstarted');
      if (!hasAdStarted) {
        return { status: 'na', message: 'Ad never started; no tracking expected' };
      }
      return { status: 'fail', message: 'No tracking requests detected during ad playback' };
    }

    const pixels = session.networkLog.filter(e => e.initiator === 'pixel');
    const fetches = session.networkLog.filter(e => e.initiator === 'fetch');
    const beacons = session.networkLog.filter(e => e.initiator === 'beacon');

    return {
      status: 'pass',
      message: `${session.networkLog.length} request(s): ${pixels.length} pixel, ${fetches.length} fetch, ${beacons.length} beacon`,
    };
  },
};
